export default __webpack_public_path__ + "static/image-2021-12-21-10-15-21-540-d9102dfad4e1c24ff5b1899ffaa9071c.png";